// extracted by mini-css-extract-plugin
export default {"disabledCell":"my-software-table_disabledCell__LWQrs","invisible":"my-software-table_invisible__Eyntx"};